module.exports = __webpack_public_path__ + "static/media/tacktalk-app_2screen.ce00a3a9.png";